interface FieldErrorMessageProps {
  error?: {
    message?: string
  }
}

export const FieldErrorMessage = ({ error }: FieldErrorMessageProps) => {
  if (!error) return null

  return (
    <div role="alert" className="d-block mt-0 invalid-feedback">
      {error.message}
    </div>
  )
}
